/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MaxFileSizeSettingParser = /* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('MAX_FILE_SIZE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class MaxFileSizeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MaxFileSizeSettingParser.decode(input).map(res => new MaxFileSizeSetting(res));
    }
    static unsafeDecode(input) {
        return MaxFileSizeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MaxFileSizeSettingParser.encode(data);
    }
    static schema() {
        return MaxFileSizeSettingParser.schema();
    }
}
